import { Box, Text, Image } from '@chakra-ui/react';
import React from 'react';
import { PotentialInvestors } from '../../interfaces/components';

interface PotentialInvestorsTabProps {
  potentialInvestorsData: PotentialInvestors[];
}

export default function PotentialInvestorsTab(props: PotentialInvestorsTabProps) {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const { potentialInvestorsData } = props;

  return (
    <>
      {/* <InvestorsModal onClose={onClose} isOpen={isOpen} onOpen={onOpen} /> */}
      <Box marginTop="28px">
        <Text fontSize={'24px'} fontWeight={600} color="#000">
          Potential Investors
        </Text>
        <Text fontSize={'14px'} fontWeight={400} color="rgba(0, 0, 0, 0.50)" marginTop="10px">
          These are investors that have backed related projects.
        </Text>
        <Box mt="32px" display="flex" gap="18px" flexWrap="wrap">
          {potentialInvestorsData?.length > 0 &&
            potentialInvestorsData.map((item: any, index: React.Key | null | undefined) => (
              <Box
                borderRadius="12px"
                border="1px solid rgba(0, 0, 0, 0.10)"
                background="#FFF"
                padding="24px"
                key={index}
                width={{ base: '100%', md: 'calc(50% - 9px)' }} // Adjusting width based on screen size
                // onClick={onOpen}
                cursor="pointer"
              >
                <Box display="flex" alignItems="center" gap="7px">
                  <Box>
                    <Image
                      src={item.logo}
                      alt="Dan Abramov"
                      width="36px"
                      height="36px"
                      borderRadius="50%"
                      referrerPolicy="no-referrer"
                    />
                  </Box>
                  <Text color=" rgba(0, 0, 0, 0.85)" fontSize="17px" fontWeight="600">
                    {item?.name}
                  </Text>
                </Box>
                {/* <Text color="rgba(0, 0, 0, 0.50)" fontSize="12px" fontWeight="600" mt="12px">
                  Lorem ipsum dolor sit amet consectetur.
                </Text> */}
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
}
